import { isPlatformBrowser } from '@angular/common';
import { ApplicationConfig, PLATFORM_ID, inject } from '@angular/core';
import {
  ApolloClientOptions,
  ApolloLink,
  DefaultOptions,
  InMemoryCache,
} from '@apollo/client/core';
import { environment } from '@shared/envs/env';
import { provideNamedApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

export const graphqlProvider: ApplicationConfig['providers'] = [
  provideNamedApollo(() => {
    const httpLink = inject(HttpLink);
    const platformId = inject(PLATFORM_ID);

    const cache = new InMemoryCache({
      addTypename: false,
    });

    const authLink = ApolloLink.from([
      httpLink.create({
        uri: environment.authUrl,
      }),
    ]);

    const approveTvLink = ApolloLink.from([
      httpLink.create({
        uri: environment.approveTvUrl,
      }),
    ]);

    const accountLink = ApolloLink.from([
      httpLink.create({
        uri: environment.accountUrl,
      }),
    ]);

    const apiLink = ApolloLink.from([
      httpLink.create({
        uri: isPlatformBrowser(platformId) ? environment.apiUrl : environment.ssrApiUrl,
      }),
    ]);

    const supportLink = ApolloLink.from([
      httpLink.create({
        uri: environment.supportUrl,
      }),
    ]);

    const defaultOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
      query: {
        fetchPolicy: 'no-cache',
      },
      mutate: {
        fetchPolicy: 'no-cache',
      },
    };

    const apiClient: ApolloClientOptions<any> = {
      cache,
      link: apiLink,
      defaultOptions,
    };

    const authClient: ApolloClientOptions<any> = {
      cache: cache,
      link: authLink,
      defaultOptions: defaultOptions,
    };

    const approveTvClient: ApolloClientOptions<any> = {
      cache: cache,
      link: approveTvLink,
      defaultOptions: defaultOptions,
    };

    const accountClient: ApolloClientOptions<any> = {
      cache: cache,
      link: accountLink,
      defaultOptions: defaultOptions,
    };

    const supportClient: ApolloClientOptions<any> = {
      cache: cache,
      link: supportLink,
      defaultOptions: defaultOptions,
    };

    return {
      default: apiClient,
      apiClient,
      authClient,
      approveTvClient,
      accountClient,
      supportClient,
    };
  }),
];
